export default "__VITE_ASSET__BluiSulJ__"